// 贵、蛇、雀、合、勾、龙、空、虎、常、玄、阴、后
export const ShenJiangArray = ["贵人", "腾蛇", "朱雀", "六合", "勾陈", "青龙", "天空", "白虎", "太常", "玄武", "太阴", "天后"]
// 甲戊庚牛羊，乙己鼠猴乡，丙丁猪鸡位，壬癸蛇兔藏，六辛逢虎马，此是贵人方。辰戌魁罡位，贵人不到场。
export const YangGui = {
    "甲": "丑",
    "戊": "丑",
    "庚": "丑",
    "乙": "子",
    "己": "子",
    "丙": "亥",
    "丁": "亥",
    "壬": "巳",
    "癸": "巳",
    "辛": "午",
}
export const YinGui = {
    "甲": "未",
    "戊": "未",
    "庚": "未",
    "乙": "申",
    "己": "申",
    "丙": "酉",
    "丁": "酉",
    "壬": "卯",
    "癸": "卯",
    "辛": "寅",
}
/**
 * 阳贵人:
 * 如果用事时间是白天，也就是卯时到申时，就使用阳贵人。
 * 阴贵人:
 * 如果用事时间是夜晚，也就是酉时到寅时，就使用阴贵人。
 */
export const YinYang = {
    "卯": "阳",
    "辰": "阳",
    "巳": "阳",
    "午": "阳",
    "未": "阳",
    "申": "阳",
    "酉": "阴",
    "戌": "阴",
    "亥": "阴",
    "子": "阴",
    "丑": "阴",
    "寅": "阴",
}
/**
 * 顺时针排	亥子丑寅卯辰
 * 逆时针排	巳午未申酉戌
 */
export const ShunNi = {
    "亥": "顺",
    "子": "顺",
    "丑": "顺",
    "寅": "顺",
    "卯": "顺",
    "辰": "顺",
    "巳": "逆",
    "午": "逆",
    "未": "逆",
    "申": "逆",
    "酉": "逆",
    "戌": "逆",
}